module.exports = "../fonts/SFUIText-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Bold.ttf
// module id = 575
// module chunks = 0